import {useEffect, useRef} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

import {useTelephony} from '../../hooks/useTelephony'

const hasMeaningfulValue = (value?: string | null) => {
  const normalized = String(value || '').trim().toUpperCase()
  return Boolean(normalized && !['0', 'NONE', 'NULL', 'N/A'].includes(normalized))
}

const isLiveCallStatus = (status?: string, subStatus?: string) => {
  const values = [status, subStatus]
    .map((value) => String(value || '').trim().toUpperCase())
    .filter(Boolean)
  if (!values.length) return false
  return values.some((value) =>
    ['INCALL', 'LIVE', 'QUEUE', 'RING'].some((marker) => value.includes(marker))
  )
}

export const VicidialScreenPop: React.FC = () => {
  const telephony = useTelephony()
  const navigate = useNavigate()
  const location = useLocation()
  const lastPoppedKeyRef = useRef('')

  const {
    vendorLeadCode,
    callId,
    sessionId,
    status,
    realTimeSubStatus,
    activeSession,
  } = telephony.vicidialSession

  useEffect(() => {
    if (!activeSession) return
    if (!hasMeaningfulValue(vendorLeadCode)) return
    if (!isLiveCallStatus(status, realTimeSubStatus)) return

    const leadId = String(vendorLeadCode).trim()
    if (!/^\d+$/.test(leadId)) return

    const popKey = [leadId, sessionId || '', callId || ''].join('|')
    if (popKey === lastPoppedKeyRef.current) return

    const targetPath = `/lead/${leadId}`
    if (location.pathname === targetPath) {
      lastPoppedKeyRef.current = popKey
      return
    }

    lastPoppedKeyRef.current = popKey
    navigate(targetPath)
  }, [
    activeSession,
    callId,
    location.pathname,
    navigate,
    realTimeSubStatus,
    sessionId,
    status,
    vendorLeadCode,
  ])

  return null
}
